import { useState, useContext } from 'react';

import { updateDoc, doc } from 'firebase/firestore';

import { db } from '../../../../firebase_config';

import { UserContext } from '../../../UserContext';

import { ModalWindow } from '../../../../Components/ModalWindow';
import { LikeIcon } from '../../../../Components/SvgComponents/LikeIcon';
import { GoodModal } from '../GoodModal/GoodModal';

export const GoodCard = ({ data: { name, img, house, price, description, id } }) => {
  const { user, wishList, setWishList } = useContext(UserContext);
  const [isModalOpened, setOpenModal] = useState(false);
  const isInList = Boolean(wishList.find((element) => element.id === id));

  const handleToggleWishList = () => {
    const userRef = doc(db, 'users', user.uid);

    if (isInList) {
      const newWishList = wishList.filter((values) => values.id !== id);

      setWishList(newWishList);
      updateDoc(userRef, { wishList: newWishList });
    } else {
      const newWishList = [...wishList, { name, img, house, price, description, id }];

      setWishList(newWishList);
      updateDoc(userRef, { wishList: newWishList });
    }
  };

  return (
    <>
      <div className="bg-white relative w-78 h-96 p-3 flex justify-center duration-300 rounded-2xl hover:shadow-cardHover cursor-pointer">
        <div className="border border-indigo-500 flex flex-col justify-between items-center">
          <section className="w-full h-full flex flex-col justify-between items-center opacity-100 visible duration-700 z-20">
            <img className="block w-60 h-60" src={img} alt="poster" />
            <h2 className="font-crimson font-medium text-xl leading-6 flex tracking-wider text-center">{name}</h2>
            <div className="flex gap-8 items-center mb-4">
              <span className="font-crimson font-bold text-lg leading-6 flex tracking-wider">£{price}</span>
              <button
                className="h-12 w-28 font-crimson font-normal text-base leading-8 tracking-wider flex justify-center items-center duration-500 bg-transparent border-2 rounded-3xl border-borderColor hover:text-font hover:bg-borderColor"
                onClick={() => {
                  setOpenModal(true);
                }}>
                View More
              </button>
            </div>
          </section>
        </div>
        <div className="w-36 h-48 absolute left-2 bottom-2 bg-white z-10"></div>
        <div className="w-36 h-48 absolute right-2 top-2 bg-white z-10"></div>
        {user && (
          <div className="w-8 h-8 absolute right-3 top-3 z-30" onClick={handleToggleWishList}>
            <LikeIcon isActive={isInList} />
          </div>
        )}
      </div>
      {isModalOpened && (
        <ModalWindow closeModal={() => setOpenModal(false)}>
          <GoodModal
            name={name}
            img={img}
            house={house}
            price={price}
            description={description}
            id={id}
            onClose={() => setOpenModal(false)}
          />
        </ModalWindow>
      )}
    </>
  );
};
